function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { arrayOf, bool, number, string, shape } from 'prop-types';
import { ADDRESS_TYPES } from './constants';

// Should match shape of address validator in Core
export var addressPropType = {
  address_type: string,
  line_1: string,
  line_2: string,
  city: string,
  county: string,
  state: string,
  postal_code: string,
  country: string,
  latitude: number,
  longitude: number,
  is_primary: bool
};
export var InitialAddresses = shape(_defineProperty(_defineProperty(_defineProperty({}, ADDRESS_TYPES.CLIENT, arrayOf(shape(addressPropType))), ADDRESS_TYPES.USER, arrayOf(shape(addressPropType))), ADDRESS_TYPES.GROUP, arrayOf(shape(addressPropType))));
export var AddressOptionGroupProps = shape({
  id: string.isRequired,
  name: string.isRequired,
  children: arrayOf(shape(_objectSpread(_objectSpread({}, addressPropType), {}, {
    id: string,
    address_type: string
  })))
});
export var contactPropType = shape({
  first_name: string,
  last_name: string,
  phone_numbers: arrayOf(shape({
    extension: string,
    is_primary: bool,
    phone_type: string,
    country_code: string,
    phone_number: string,
    acceptable_communication_types: arrayOf(string),
    id: number
  })),
  email_addresses: arrayOf(shape({
    is_primary: bool,
    email_address: string,
    acceptable_communication_types: arrayOf(string),
    id: number
  })),
  date_of_birth: number,
  gender: string,
  addresses: arrayOf(shape(addressPropType)),
  household: shape({
    total: number,
    adults: number,
    children: number
  })
});
//# sourceMappingURL=propTypes.js.map